import { LIST, LOADING, OTHERINFO } from '../../types/dashboard'
// **  Initial State
const initialState = {
  data: [],
  params: {},
  loading: true,
  all: [],
}

const currentStockReport = (state = initialState, action) => {
  switch (action.type) {
    case LIST:
      return {
        ...state,
        data: action.payload,
        loading: false,
      }
    case LOADING:
      return {
        ...state,
        loading: action.payload,
      }
    default:
      return state
  }
}

export default currentStockReport
